import React, { useState, useRef } from 'react';
import DataGrid, {
    Column,
    ColumnChooser,
    Editing,
    Export,
    FilterRow,
    HeaderFilter,
    Lookup,
    Pager,
    Paging,
    Popup as PopupGrid,
    Form as FormGrid,
    Button as ButtonGrid,
    RequiredRule
} from 'devextreme-react/data-grid';
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { createStoreLocal } from '../../utils/proxy';
import uri from '../../utils/uri';
import { store } from '../../services/store';
import { dataFormatId } from '../../utils/common';
import { addMenu } from '../../components/grids/Menu';
import { dialogPayment } from '../../store/payment/paymentDialogReducer';
import { useDispatch, useSelector } from 'react-redux'
import { editorOptionsSelect, formatDate, formatDateTime } from '../../data/app';
import http from '../../utils/http';
import useApi from '../../hooks/useApi';
import { Form } from 'devextreme-react';
import { SimpleItem, Label } from 'devextreme-react/form';

const Payments = (props) => {

    const { open, id } = useSelector(store => store.paymentDialog);
    const [ paymentStates, setPaymentStates ] = useState(1);
    const [ saved, setSaved ] = useState(false);

    const { data, isLoading } = useApi({ url: uri.compras.getById(id) });


    let dataGrid = useRef();
    const dispatch = useDispatch();


    const addMenuItems = (e) => {
        addMenu(e, [{
            text: `Realizar nuevo pago`,
            icon: '',
            onItemClick: () => dataGrid.current.instance.addRow()
        }])
    }

    const closeDialog = (load) => {

        dispatch(dialogPayment({ open: false, id: 0 }));
        if (load) {
            let { onSave } = props;
            onSave();
        }
    }

    const onHiding = ({ load }) => {
        closeDialog(saved);
    }

    const onInitNewRow = (e) => {
        e.data.date = new Date();
        e.data.purchaseId = id;
    }

    const onRowInserted = (e) => {
        setSaved(true);
    }

    const _uri = uri.purchaseReceipts;

    const currencies = [{ id: 1, name: 'Córdobas' }, { id: 2, name: 'Dólares' }];

    const onToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Agregar nuevo pago',
                icon: 'plus',
                type: 'default',
                stylingMode: "outlined",
                onClick: () => dataGrid.current.instance.addRow()
            }
        },{
            location: 'after',
            widget: 'dxSelectBox',
            options: {
                dataSource: [{
                    id: 0, name: 'Inactivos'
                },{
                    id: 1, name: 'Activos'
                },{
                    id: 2, name: 'Todos'
                }],
                ...editorOptionsSelect,
                value: paymentStates,
                onValueChanged: (e) => {
                    setPaymentStates(e.value);
                }
            }
        });
    }

    const title = "Pagos";

    let extraParameter = [];
    if(paymentStates === 0) extraParameter = [['active', false]];
    if(paymentStates === 1) extraParameter = [['active', true]];

    extraParameter.push(['purchaseId', id]);

    const formData = data?.length == 0 ? {} : data;

    return (
        <div className="container">
            <Popup
                width={'95vw'}
                height={'95vh'}
                title={`Pagos`}
                onHiding={onHiding}
                visible={open}
                id='bill-panel'
            >
                <Form formData={formData} readOnly={true} colCount={4} >
                    <SimpleItem dataField={'id'} />
                    <SimpleItem dataField={'date'} editorType="dxDateBox" editorOptions={{ displayFormat: formatDateTime }} >
                        <Label text="Fecha" />
                    </SimpleItem>
                    <SimpleItem dataField="purchaseTypeId" editorType="dxSelectBox"
                        editorOptions={{
                            dataSource: createStoreLocal({ name: 'purchaseType' }),
                            ...editorOptionsSelect,
                        }} >
                        <Label text="Tipo de compra" />
                    </SimpleItem>
                    <SimpleItem dataField={'total'} editorOptions={{ format: { type: 'fixedPoint', precision: 2 } }} />
                    <SimpleItem dataField="purchasePaymentTypeId" colSpan={1} editorType="dxSelectBox"
                        editorOptions={{
                            dataSource: createStoreLocal({ name: 'purchasePaymentType' }),
                            ...editorOptionsSelect
                        }} >
                        <Label text="Tipo de pago:" />
                    </SimpleItem>

                    <SimpleItem dataField="providerId" colSpan={1} editorType="dxSelectBox"
                        editorOptions={{
                            dataSource: createStoreLocal({ name: 'Provider' }),
                            ...editorOptionsSelect
                        }} >
                        <Label text="Proveedor" />
                    </SimpleItem>

                    <SimpleItem dataField="reference" colSpan={1}>
                        <Label text="Referencia" />
                    </SimpleItem>

                    <SimpleItem dataField="rate" colSpan={1} >
                        <Label text="Tipo cambio" />
                    </SimpleItem>

                    <SimpleItem dataField="creditDays" colSpan={1} editorOptions={{

                    }}>
                        <Label text="Días de crédito" />
                    </SimpleItem>

                    <SimpleItem dataField="currencyId" colSpan={1} editorType="dxSelectBox"
                        editorOptions={{
                            dataSource: currencies,
                            ...editorOptionsSelect,
                        }} >
                        <Label text="Moneda" />
                    </SimpleItem>
                    <SimpleItem dataField="observation" colSpan={2} editorType="dxTextBox">
                        <Label text="Observacion" />
                    </SimpleItem>
                </Form>
                <DataGrid id="gridContainer"
                    ref={dataGrid}
                    selection={{ mode: 'single' }}
                    dataSource={id > 0 ? store({ uri: _uri, remoteOperations: true, extraParameter }) : []}
                    showBorders={true}
                    showRowLines={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    hoverStateEnabled={true}
                    // onRowPrepared={onRowPrepared}
                    // onCellPrepared={onCellPrepared}
                    onToolbarPreparing={onToolbarPreparing}
                    onContextMenuPreparing={addMenuItems}
                    onInitNewRow={onInitNewRow}
                    onRowInserted={onRowInserted}
                    remoteOperations={{
                        paging: true,
                        filtering: true
                    }}
                >
                    <Paging defaultPageSize={20} />
                    <Pager
                        showInfo={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={[10, 20, 50]}
                    />
                    <FilterRow visible={true} />
                    <HeaderFilter visible={true} />
                    <ColumnChooser enabled={true} />
                    <Export enabled={true} fileName={title} allowExportSelectedData={true} />
                    <Column dataField="id" caption='Numero' width={100} cellRender={dataFormatId} allowEditing={false} />
                    <Column dataField="date" caption='Fecha' dataType='date' format={formatDate} width={120} />
                    <Column dataField="amount" caption='Monto Pagado' dataType='number' format={{ type: 'fixedPoint', precision: 2 }} width={120} />
                    <Column dataField="balance" caption='Monto Pendiente' dataType='number' format={{ type: 'fixedPoint', precision: 2 }} width={120} />
                    <Column dataField="referencePhysical" caption='Referencia Física' width={100} />


                    <Column dataField="paymentMethodId" caption="Tipo de Pago" width={90}>
                        <Lookup disabled={true} dataSource={createStoreLocal({ name: 'billPaymentMethod' })} valueExpr="id" displayExpr="name" />
                    </Column>

                    <Column dataField="bankId" caption="Banco" width={90}>
                        <Lookup disabled={true} dataSource={createStoreLocal({ name: 'bank' })} valueExpr="id" displayExpr="name" />
                    </Column>
                    <Column dataField="reference" caption='Referencia' width={100} />
                    <Column dataField="observation" caption='Observacion' visible={true} allowHeaderFiltering={false} allowFiltering={false} />
                    <Column dataField="createAt" caption='Creado el' dataType='date' visible={false} format={formatDateTime} width={180} />
                    <Column dataField="createBy" caption='Creado Por' width={120} />
                    <Column dataField="active" caption='Activo' width={120} />

                    <Editing
                        mode="popup"
                        allowDeleting={true}
                        allowAdding={true}
                        allowUpdating={true}
                        useIcons={true}
                        
                    >
                        <PopupGrid title="Editar Pago" showCloseButton={true} showTitle={true} width={600} height={450}>

                        </PopupGrid>
                        <FormGrid colCount={1}>
                            <SimpleItem dataField="date" editorType="dxDateBox" editorOptions={{ displayFormat: formatDate }}>
                                <Label text="Fecha" />
                                <RequiredRule message="La fecha es requerida" />
                            </SimpleItem>
                            <SimpleItem dataField="amount" editorType="dxNumberBox">
                                <Label text="Monto" />
                                <RequiredRule message="El monto es requerido" />
                            </SimpleItem>
                            <SimpleItem dataField="paymentMethodId" editorType="dxSelectBox">
                                <Label text="Método de Pago" />
                                <RequiredRule message="El monto es requerido" />
                            </SimpleItem>
                            <SimpleItem dataField="bankId" editorType="dxSelectBox">
                                <Label text="Banco" />
                            </SimpleItem>
                            <SimpleItem dataField="reference" editorType="dxTextBox">
                                <Label text="Referencia" />
                            </SimpleItem>
                            <SimpleItem dataField="observation" editorType="dxTextArea">
                                <Label text="Observación" />
                            </SimpleItem>
                        </FormGrid>
                    </Editing>

                </DataGrid>
            </Popup>
        </div>
    );
}

export default Payments;